/*
 * @Author: daiqi@sogou-inc.com
 * @Date: 2022-02-24 17:55:58
 * @Description: 明星详情页
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    query: '',
    searchData: {},
    starEntity: {},
    starTab: '',
  }),
  mutations: {
    [types.UPDATE_HEAD](state, str) {
      state.head = str;
    },
    [types.UPDATE_STAR_QUERY](state, str) {
      state.query = str;
    },
    [types.UPDATE_STAR_SEARCH_DATA](state, obj) {
      state.searchData = obj;
    },
    [types.UPDATE_STAR_ENTITY](state, obj) {
      state.starEntity = obj;
    },
    [types.UPDATE_STAR_TAB](state, str) {
      state.starTab = str;
    },
  },
  actions: {
    /**
    * 获取短视频结果页数据
    */
    async prefetchData({ commit, rootState }, { context, route }) {
      const $params = context ? context.$params : {};
      const key = route.params.key || '';
      const params = Object.assign({}, route.query, $params, { key });
      const config = rootState.common.$config || {};
      const { qua, wxAppEnable, wxAppVersion, xWebEnable, iskd, guid, qbid, isHitKd } = config;
      if (iskd === 1 && +isHitKd === 1) {
        Object.assign(params, {
          qua,
          wxAppEnable,
          wxAppVersion,
          xWebEnable,
          iskd,
          guid,
          qbid,
          isHitKd,
        });
      }

      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/starsearch`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));
      result = result.data || {};
      const { status, redirectUrl } = result;

      if (status === 0) {
        const {
          head = '',
          query = '',
          searchData = {},
          starEntity = {},
          starTab = '',
          loadingFinished = false,
        } = result.data;

        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_STAR_QUERY, query);
        commit(types.UPDATE_STAR_SEARCH_DATA, searchData);
        commit(types.UPDATE_STAR_ENTITY, starEntity);
        commit(types.UPDATE_STAR_TAB, starTab);
        commit(`common/${types.UPDATE_LOADING_FINISHED}`, loadingFinished, { root: true });
        return result.data;
      }
      if (status === 301) return result;
      if (status === 404) return { status: 404 };
      return {
        status: 302,
        redirectUrl: redirectUrl || '/?prefetch_redirect=1',
      };
    },
  },
};
